<template>
<div>
 <form @submit.prevent="addComment" @keydown="form.errors.clearall()">
    <div class="form-group">
      <input type="text" v-model="form.title" placeholder="კითხვის/კომენტარის სათაური" class="form-control">
       <p class='text-danger mt-m-20'
            v-if="form.errors.has('text')">გთოვთ შეიყვანოთ სათაური</p>
    </div>
    <div class="form-group">
        <textarea v-model="form.text" height="20" name="" id=""  placeholder="კითხვის/კომენტარის ტექსტი" class="form-control"></textarea>
    </div>
    <div class="form-group">
      <!-- <button class="btn btn-sm btn-info">დამატება</button> -->
      <button class="btn btn-sm btn-info">დამატება</button>
    </div>
 </form>
</div>
</template>

<script>
  import { Form } from './../../../form/form.js'
    export default {
       props:[],
       // components: { draggable },
       data(){
        return{
           form: new Form({ title:'', text:'' }),
        }
       },
       methods:{
        addComment(){
            // axios.post(`${location.pathname}/replies`, { body:this.body })
            //     .then(data => {
                    window.bus.$emit('commentCreated', this.form.data())
                    this.form.reset()
                // })
                //  .catch(error => {
                //     console.log(error.response)
                //     flash(error.response.data, 'danger')
                // })
        }
       }
     }
</script>
